// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"1929ff71","453":"6c084524","553":"0042da19"}[chunkId] + ".chunk.js";
};